// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper--_DD0T {
  width: 100%;
  height: 100%;
  min-height: 100%;
}

.wrapper--_DD0T iframe {
  width: 100% !important;
  height: 100%;
  min-height: 100%;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/common/components/iframe-component/iframe.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".wrapper {\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n}\n\n.wrapper iframe {\n  width: 100% !important;\n  height: 100%;\n  min-height: 100%;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `wrapper--_DD0T`;
export default ___CSS_LOADER_EXPORT___;
